import * as React from "react";
const SkewedBarSVG = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={23}
    height={26}
    fill="none"
    {...props}
  >
    <path fill="#EF4136" d="M0 25.982 9.63 0H23l-5.587 13-5.588 13L0 25.982Z" />
  </svg>
);
export default SkewedBarSVG;
